import React from 'react';

interface SelectedAgents {
  resume_tweaker: boolean;
  skill_gap_analysis: boolean;
  interview_questions: boolean;
}

interface AgentSelectorProps {
  selectedAgents: SelectedAgents;
  onAgentsChange: (agents: SelectedAgents) => void;
}

const AgentSelector: React.FC<AgentSelectorProps> = ({ selectedAgents, onAgentsChange }) => {
  const handleAgentToggle = (agent: keyof typeof selectedAgents) => {
    onAgentsChange({
      ...selectedAgents,
      [agent]: !selectedAgents[agent]
    });
  };

  return (
    <div>
      <h2>🤖 Select AI Agents</h2>
      <p>Choose which AI agents you want to run on your resume:</p>
      
      <div className="grid grid-3">
        <div className="card" style={{ padding: '16px', textAlign: 'center' }}>
          <h3>📝 Resume Tweaker</h3>
          <p>Improves your resume to better match job requirements</p>
          <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={selectedAgents.resume_tweaker}
              onChange={() => handleAgentToggle('resume_tweaker')}
            />
            Enable Resume Tweaker
          </label>
        </div>

        <div className="card" style={{ padding: '16px', textAlign: 'center' }}>
          <h3>🔍 Skill Gap Analysis</h3>
          <p>Identifies missing skills and experiences</p>
          <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={selectedAgents.skill_gap_analysis}
              onChange={() => handleAgentToggle('skill_gap_analysis')}
            />
            Enable Gap Analysis
          </label>
        </div>

        <div className="card" style={{ padding: '16px', textAlign: 'center' }}>
          <h3>❓ Interview Questions</h3>
          <p>Generates tailored interview questions</p>
          <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={selectedAgents.interview_questions}
              onChange={() => handleAgentToggle('interview_questions')}
            />
            Enable Question Generator
          </label>
        </div>
      </div>
    </div>
  );
};

export default AgentSelector;
